import type { GridRow } from "./grid";

// Not grid.ts's countFilled: importing grid.ts at runtime would pull the column
// detector into the dashboard bundle along with this tiny store.
function countFilled(rows: GridRow[]): number {
  return rows.filter((row) => row.article.trim() !== "" || row.quantity.trim() !== "").length;
}

/** The import list the dealer is working on, kept across a closed dialog or a page change. */
export interface ImportDraft {
  rows: GridRow[];
  fileName?: string;
}

const STORAGE_KEY = "order-import-draft";

function load(): ImportDraft | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    const draft = raw ? (JSON.parse(raw) as ImportDraft) : null;
    return draft && Array.isArray(draft.rows) ? draft : null;
  } catch {
    return null;
  }
}

let current: ImportDraft | null = load();
const listeners = new Set<() => void>();

/**
 * One draft per tab (sessionStorage): a list survives an accidental close, a trip to
 * the catalog to look something up, or a partial add — and every «Загрузить по
 * артикулу» button can offer to continue it. Storage failures (private mode, quota)
 * just make it a per-page draft.
 */
export const importDraft = {
  get(): ImportDraft | null {
    return current;
  },
  set(draft: ImportDraft | null) {
    current = draft && countFilled(draft.rows) > 0 ? draft : null;
    try {
      if (current) sessionStorage.setItem(STORAGE_KEY, JSON.stringify(current));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      // Not persisted; the in-memory copy still serves this page.
    }
    listeners.forEach((listener) => listener());
  },
  subscribe(listener: () => void) {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  /** Filled rows in the draft, for «Продолжить загрузку (N)». */
  filledRows(): number {
    return current ? countFilled(current.rows) : 0;
  },
};
